import { API_URL } from "../../global/components/Constants";
import { parseMarginPadding, parseItemResult } from '../controlUtils';

export function displaySectionUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const display = content.Display;
    const size = content.Size;

    let sizeParams = {
        name: size,
        title: 0,
        desc: 0,
        zoom: 0
    }

    if(size == "small"){
        sizeParams.title = 24;
        sizeParams.desc = 16;
    }
    else if(size == "medium"){
        sizeParams.title = 28;
        sizeParams.desc = 18;
    }
    else if(size == "large"){
        sizeParams.title = 36;
        sizeParams.desc = 20;
    }
    else if(size == "presentation"){
        sizeParams.title = 34;
        sizeParams.desc = 26;
    }

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { sizeParams.title = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { sizeParams.desc = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { sizeParams.zoom = parseInt(ptn.Zoom) }
    }

    if(entryPoint == "editor"){
        sizeParams.zoom = 40;
    }

    const params = {
        obj: obj,
        entryPoint, entryPoint,
        content: content,
        size: sizeParams
    }

    let section = <></>;

    if(display == "default"){
        section = defaultSection(params);
    }
    else if(display == "expand"){
        section = expandSection(params);
    }
    else if(display == "compact-right"){
        section = compactRightSection(params);
    }
    else if(display == "compact-left"){
        section = compactLeftSection(params);
    }

    return section;
    
}

function defaultSection(params){

    const obj = params.obj;
    const entryPoint = params.entryPoint;
    const content = params.content;
    const photo = obj.Photo;
    const size = params.size;   

    const display = content.Display;
    const theme = content.Theme;
    const title = content.Title;
    const desc = content.Description;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        section: {
            display:'flex',
            background: bgColor,
            minWidth:300,
            zoom: `${size.zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            border: (bgColor == "#fff" || bgColor == "#ffffff")? '1px solid #dedede': 'none',
            borderRadius: 5,
        },
        photoWrap:{
            flex: 1,
            marginLeft: mp.paddingLeft,
        },
        photo:{
            holder:{
                background: '#e5ecee', 
                height: 300, 
                width: 'auto', 
                marginBottom:0,
                borderRadius: 5
            },
            img:{
                width: '100%',
                marginBottom:0,
                borderRadius: 5
            }
        },
        contentWrap:{
            flex: 1
        },
        title:{
            color: txtColor,
            fontSize: size.title
        },
        desc:{
            color: txtColor,
            fontSize: size.desc
        }
    }

    return (
        <div style={styles.section}>
            <div style={styles.contentWrap}>
                <h4 style={styles.title}>
                    {parseItemResult(title, obj, entryPoint, 0.3)}
                </h4>
                <div style={styles.desc}>
                    {parseItemResult(desc, obj, entryPoint, 0.6)}
                </div>
            </div>
            <div style={styles.photoWrap}>
                {parseItemResult(displayImage(photo, styles.photo), obj, entryPoint, 0)}
            </div>
        </div>
    )
}

function expandSection(params){

    const obj = params.obj;
    const entryPoint = params.entryPoint;
    const content = params.content;
    const photo = obj.Photo;
    const size = params.size; 

    const display = content.Display;
    const theme = content.Theme;
    const title = content.Title;
    const desc = content.Description;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        section: {
            display: 'flex',
            background: bgColor,
            zoom: `${size.zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            border: (bgColor == "#fff" || bgColor == "#ffffff")? '1px solid #dedede': 'none',
            borderRadius: 5,
        },
        photoWrap:{
            flex: 1,
            marginRight: mp.paddingRight,
        },
        photo:{
            holder:{
                background: '#e5ecee', 
                height: 300, 
                width: 'auto', 
                marginBottom:0,
                borderRadius: 5
            },
            img:{
                width: '100%',
                marginBottom:0,
                borderRadius: 5
            }
        },
        contentWrap:{
            flex: 1
        },
        title:{
            color: txtColor,
            fontSize: size.title
        },
        desc:{
            color: txtColor,
            fontSize: size.desc
        }
    }

    return (
        <div style={styles.section}>
            <div style={styles.photoWrap}>
                {parseItemResult(displayImage(photo, styles.photo), obj, entryPoint, 0)}
            </div>
            <div style={styles.contentWrap}>
                <h4 style={styles.title}>
                    {parseItemResult(title, obj, entryPoint, 0.3)}
                </h4>
                <div style={styles.desc}>
                    {parseItemResult(desc, obj, entryPoint, 0.6)}
                </div>
            </div>
        </div>
    )
}

function compactRightSection(params){

    const obj = params.obj;
    const entryPoint = params.entryPoint;
    const content = params.content;
    const photo = obj.Photo;
    const size = params.size; 

    const display = content.Display;
    const theme = content.Theme;
    const title = content.Title;
    const desc = content.Description;
    const marginPadding = content.MarginPadding;

    const src = (photo.length > 200)? photo: `${API_URL}/uploads/topic/component/${photo}`;
    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        section: {
            background: bgColor,
            display:'flex',
            overflow: 'hidden',
            zoom: `${size.zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            border: (bgColor == "#fff" || bgColor == "#ffffff")? '1px solid #dedede': 'none',
            borderRadius: 5,
        },
        contentWrap:{
            flex: 1,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        title:{
            color: txtColor,
            fontSize: size.title
        },
        desc:{
            color: txtColor,
            fontSize: size.desc
        },
        photoWrap:{
            flex: 1,
            background: '#e5ecee', 
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }
    }

    return (
        <div style={styles.section}>
            <div style={styles.contentWrap}>
                <h4 style={styles.title}>
                    {parseItemResult(title, obj, entryPoint, 0.3)}
                </h4>
                <div style={styles.desc}>
                    {parseItemResult(desc, obj, entryPoint, 0.6)}
                </div>
            </div>
            <div style={styles.photoWrap}></div>
        </div>
    )
}

function compactLeftSection(params){

    const obj = params.obj;
    const entryPoint = params.entryPoint;
    const content = params.content;
    const photo = obj.Photo;
    const size = params.size; 

    const display = content.Display;
    const theme = content.Theme;
    const title = content.Title;
    const desc = content.Description;
    const marginPadding = content.MarginPadding;

    const src = (photo.length > 200)? photo: `${API_URL}/uploads/topic/component/${photo}`;
    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    const styles = {
        section: {
            background: bgColor,
            display:'flex',
            overflow: 'hidden',
            zoom: `${size.zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            border: (bgColor == "#fff" || bgColor == "#ffffff")? '1px solid #dedede': 'none',
            borderRadius: 5,
        },
        contentWrap:{
            flex: 1,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        title:{
            color: txtColor,
            fontSize: size.title
        },
        desc:{
            color: txtColor,
            fontSize: size.desc
        },
        photoWrap:{
            flex: 1,
            background: '#e5ecee', 
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }
    }

    return (
        <div style={styles.section}>
            <div style={styles.photoWrap}></div>
            <div style={styles.contentWrap}>
                <h4 style={styles.title}>
                    {parseItemResult(title, obj, entryPoint, 0.3)}
                </h4>
                <div style={styles.desc}>
                    {parseItemResult(desc, obj, entryPoint, 0.6)}
                </div>
            </div>
        </div>
    )
}

function displayImage(photo, styles){

    if(photo == ""){
        return <div style={styles.holder}></div>
    }
    else if(photo.length > 200){
        return <img  src = {photo} className={"photo"}  style={styles.img} />
    }
    else{
        const src = `${API_URL}/uploads/topic/component/${photo}`;
        return <img  src = {src} className={"photo"}  style={styles.img} />
    }
}